import { AdminAbilities, DocReviewAbilities, ParalegalAbilities } from '../Can/ability';
// IMPORT PROJECT REFERENCES
import {
    AnalysesPage,
    AnalysisPage,
    AnalysisViewerPage,
    DocumentPage,
    HomePage,
    MonitoredDocumentComparePage,
    MonitoredDocumentVersionPage,
    SignupConfirmPage,
    SignupPage,
} from '../pages';
// IMPORT PACKAGE REFERENCES
import React, { Fragment, useEffect } from 'react';
import { Redirect, Route, Router, Switch } from 'react-router-dom';

import { AbilityContext } from '../Can';
import { Auth } from '@aws-amplify/auth';
import { Header } from '../Header/Header';
import { History } from '../../helpers';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { routeChanged } from '../state/actions/RouterActions';
import { userAvailable } from '../state/actions';

function userAttributesCallback(err, result) {
    if (err) {
        throw err;
    }
    const { username } = this;
    const userDetails = { username };
    for (let i = 0; i < result.length; i++) {
        const key = result[i].getName();
        const value = result[i].getValue();
        if (key.indexOf('custom:') === 0) {
            const customKey = key.split(':').slice(1).join(':');
            userDetails[customKey] = value;
        } else {
            userDetails[key] = value;
        }
    }

    if (userDetails['isAdmin'] === '1') {
        this.abilities = AdminAbilities;
    } else if (userDetails['isDocReview'] === '1') {
        this.abilities = DocReviewAbilities;
    } else {
        this.abilities = ParalegalAbilities;
    }

    return this;
}

let historyListener;

// COMPONENT
const AppRouter = props => {
    const { user, onRouteChanged, onUserAvailable, abilities } = props;

    useEffect(() => {
        user === null &&
            Auth.currentAuthenticatedUser()
                .then((/** @type {CognitoUser} */ user) => {
                    return user.getUserAttributes((err, result) => {
                        userAttributesCallback.call(user, err, result);
                        return onUserAvailable(user);
                    });
                })
                .catch(err => {
                    console.log('error getting user atrributes', err);
                });
    }, [user, onUserAvailable]);

    historyListener ? historyListener() : onRouteChanged(History.location, History.action);
    historyListener = History.listen(onRouteChanged);

    return (
        <AbilityContext.Provider value={abilities}>
            <Router history={History}>
                <Fragment>
                    <Header />
                    <Switch>
                        <Route path="/" component={HomePage} exact={true} />
                        <Route path="/document/:id" component={DocumentPage} />

                        <Route
                            path="/monitored-document/:docId/version/:versionId"
                            component={MonitoredDocumentVersionPage}
                        />

                        <Route
                            path="/monitored-document/:docId/compare/:versionIds"
                            component={MonitoredDocumentComparePage}
                        />

                        <Route path="/analysis-viewer/:analysisId" component={AnalysisViewerPage} />
                        <Route path="/analyses" component={AnalysesPage} />

                        <Route path="/signup" component={SignupPage} />
                        <Route path="/signup-confirm" component={SignupConfirmPage} />

                        <Route path="/analysis" component={AnalysisPage} />

                        <Redirect to="/" />
                    </Switch>
                </Fragment>
            </Router>
        </AbilityContext.Provider>
    );
};

AppRouter.propTypes = {
    user: PropTypes.object,
    abilities: PropTypes.object,
    authState: PropTypes.string,
    onRouteChanged: PropTypes.func,
    onUserAvailable: PropTypes.func,
};

function mapStateToProps(state) {
    const { user, abilities } = state.auth;
    return { user, abilities };
}

function mapDispatchToProps(dispatch) {
    return {
        onRouteChanged: (location, action) => {
            return dispatch(routeChanged({ location, action }));
        },
        onUserAvailable: cognitoUser => {
            return dispatch(userAvailable(cognitoUser));
        },
    };
}

const hoc = connect(mapStateToProps, mapDispatchToProps)(AppRouter);
export { hoc as AppRouter };
